import SetFavicon from "./SetFavicon";
import withApolloProvider from "./common/providers/ApolloProvider";
import withAuthenticatorProvider from "./common/providers/AuthenticatorProvider";
import withNotificationMessageProvider from "./common/providers/NotificationMessageProvider";
import withThemeProvider from "./common/providers/theme/ThemeProvider";
import AppRoutes from "./routes/AppRoutes";
import { useSetSharedSession } from "./common/hooks/useSetSharedSession";

import "./common/setInitialData";

const App = (): JSX.Element => {
  useSetSharedSession();

  return (
    <>
      <AppRoutes />
      <SetFavicon />
    </>
  );
};

export default withApolloProvider(
  withAuthenticatorProvider(
    withThemeProvider(withNotificationMessageProvider(App))
  )
);
